import { type SVGProps, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from '../app.messages';
import { getTokens } from '../helpers/getTokens';
import { legacyEmitLoginState } from '../helpers/legacyEmitLoginState';
import { useUserTracking } from '../helpers/tracking';
import { useOnClickOutside } from '../helpers/useOnClickOutside';
import { accountButtonStyles } from '../styles';
import AccountMenu, { type StateContext } from './AccountMenu';

const AccountButton = () => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const [hasPopover, setHasPopover] = useState(false);
  const { formatMessage } = useIntl();
  const context: StateContext = {
    isLoggedIn,
    hasPopover,
    handlers: { setIsLoggedIn, setHasPopover },
  };

  useEffect(() => {
    getTokens().then((isLoggedIn) => setIsLoggedIn(isLoggedIn));
  }, []);

  useEffect(() => {
    // @TODO: Remove once Typo3 is dead. Needed for website-integration's Account.js
    if (typeof isLoggedIn === 'boolean') {
      legacyEmitLoginState(isLoggedIn);
    }
  }, [isLoggedIn]);

  useOnClickOutside(ref, () => setHasPopover(false));
  useUserTracking({ isLoggedIn });

  return (
    <span ref={ref}>
      <button
        data-testid={isLoggedIn ? 'account-icon-auth' : 'account-icon'}
        css={accountButtonStyles(Boolean(isLoggedIn))}
        onClick={() => setHasPopover(!hasPopover)}
      >
        <NINavigationAccount
          title={formatMessage(messages.myAccount)}
          style={{ width: '32px', color: 'black' }}
        />
      </button>
      {hasPopover && <AccountMenu context={context} />}
    </span>
  );
};

export function NINavigationAccount({
  title,
  ...props
}: { title: string } & SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <title>{title}</title>
      <path
        fill="currentColor"
        d="M20.667 11.667a4.667 4.667 0 1 1-9.335 0 4.667 4.667 0 0 1 9.335 0ZM19.6 16.454A5.958 5.958 0 0 1 16 17.667c-1.353 0-2.6-.456-3.605-1.214C9.681 17.648 8 21.37 8 23h16c0-1.615-1.733-5.337-4.399-6.546Z"
      />
    </svg>
  );
}

export default AccountButton;
